export default class ExpandableSection {
    constructor(containerSelector, titleSelector, listSelector, chevronSelector = null, mobileOnly = true, defaultCollapsedOnMobile = true, defaultExpandFirstOnMobile = false, defaultCollapsedOnDesktop = true, defaultExpandFirstOnDesktop = false, closeOnLinkClick = false) {
        this.sections = document.querySelectorAll(containerSelector);
        this.titleSelector = titleSelector;
        this.listSelector = listSelector;
        this.mobileOnly = mobileOnly;
        this.defaultCollapsedOnMobile = defaultCollapsedOnMobile;
        this.defaultExpandFirstOnMobile = defaultExpandFirstOnMobile;
        this.defaultExpandFirstOnDesktop = defaultExpandFirstOnDesktop;
        this.defaultCollapsedOnDesktop = defaultCollapsedOnDesktop;
        this.chevronSelector = chevronSelector;
        this.closeOnLinkClick = closeOnLinkClick;
        this.init();
        window.addEventListener('resize', () => this.handleResize());
    }

    init() {
        this.sections.forEach((section, index) => {
            const title = section.querySelector(this.titleSelector);
            const list = section.querySelector(this.listSelector);
            const chevron = this.chevronSelector ? section.querySelector(this.chevronSelector) : null;

            if (title && list) {
                // Ustawienie stylu kursora i wyłączenie zaznaczania tekstu
                title.style.cursor = 'pointer';
                title.style.userSelect = 'none';

                title.addEventListener('click', () => {
                    this.toggleList(list, chevron);
                });

                // Add click handlers for links if closeOnLinkClick is enabled
                if (this.closeOnLinkClick) {
                    this.addLinkClickHandlers(section, list, chevron);
                }
            }

            this.setInitialListState(section, list, chevron, index);
        });
    }

    addLinkClickHandlers(section, list, chevron) {
        // Find all links inside the list
        const links = section.querySelectorAll(this.listSelector + ' a');

        // Add click event listener to each link
        links.forEach(link => {
            link.addEventListener('click', () => {
                // Close the dropdown when a link is clicked
                this.collapseList(list, chevron);
            });
        });
    }

    handleResize() {
        this.sections.forEach((section, index) => {
            const list = section.querySelector(this.listSelector);
            const chevron = this.chevronSelector ? section.querySelector(this.chevronSelector) : null;
            if (list) {
                this.setInitialListState(section, list, chevron, index);
            }
        });
    }

    setInitialListState(section, list, chevron, index) {
        const isMobile = window.innerWidth <= 991;

        // Handle default-expanded classes for different devices
        if (section.classList.contains('default-expanded-mobile') && isMobile) {
            this.expandList(list, chevron);
            return;
        }

        if (section.classList.contains('default-expanded-desktop') && !isMobile) {
            this.expandList(list, chevron);
            return;
        }

        if (isMobile) {
            // Mobile state management
            if (this.defaultExpandFirstOnMobile && index === 0) {
                this.expandList(list, chevron);
            } else if (this.defaultCollapsedOnMobile) {
                this.collapseList(list, chevron);
            } else {
                this.expandList(list, chevron);
            }
        } else {
            // Desktop state management
            if (this.defaultExpandFirstOnDesktop && index === 0) {
                this.expandList(list, chevron);
            } else if (this.defaultCollapsedOnDesktop) {
                this.collapseList(list, chevron);
            } else {
                this.expandList(list, chevron);
            }
        }
    }

    toggleList(list, chevron) {
        if (this.mobileOnly && window.innerWidth >= 992) {
            return;
        }
        const isExpanded = list.style.height && list.style.height !== '0px';
        const fullHeight = list.scrollHeight + 'px';
        const isAbsolute = window.getComputedStyle(list).position === 'absolute';

        if (isExpanded) {
            list.style.height = fullHeight; // Set to full height to allow animation to zero
            window.requestAnimationFrame(() => {
                this.collapseList(list, chevron);
            });
        } else {
            list.style.height = '0px'; // Set to zero to allow animation to full height
            window.requestAnimationFrame(() => {
                this.expandList(list, chevron);
                list.addEventListener('transitionend', () => {
                    // For absolute positioned elements, we need to keep the explicit height
                    // to ensure the parent's padding-bottom works correctly
                    if (!isAbsolute) {
                        list.style.height = 'auto';
                    }
                }, { once: true });
            });
        }
    }

    collapseList(list, chevron) {
        list.style.height = '0px';
        list.style.overflow = 'hidden';
        list.style.transition = 'height 0.3s ease';
        list.classList.remove('expanded');

        // If the list has absolute positioning, remove padding from the parent container
        if (window.getComputedStyle(list).position === 'absolute') {
            const parent = list.parentElement;
            if (parent) {
                parent.style.paddingBottom = '0px';
                parent.style.transition = 'padding-bottom 0.3s ease';
            }
        }

        if (chevron) {
            chevron.style.transform = 'rotate(0deg)';
            chevron.style.transition = '0.3s ease';
        }
    }

    expandList(list, chevron) {
        const fullHeight = list.scrollHeight + 'px';
        list.style.height = fullHeight;
        list.style.overflow = 'hidden';
        list.style.transition = 'height 0.3s ease';
        list.classList.add('expanded');

        // If the list has absolute positioning, add padding to the parent container
        if (window.getComputedStyle(list).position === 'absolute') {
            const parent = list.parentElement;
            if (parent) {
                parent.style.paddingBottom = fullHeight;
                parent.style.transition = 'padding-bottom 0.3s ease';
            }
        }

        if (chevron) {
            chevron.style.transform = 'rotate(180deg)';
            chevron.style.transition = '0.3s ease';
        }
    }
}
